import { render, staticRenderFns } from "./UsuarioAfiliadoForm.vue?vue&type=template&id=1a581530&scoped=true"
import script from "./UsuarioAfiliadoForm.vue?vue&type=script&lang=js"
export * from "./UsuarioAfiliadoForm.vue?vue&type=script&lang=js"
import style0 from "./UsuarioAfiliadoForm.vue?vue&type=style&index=0&id=1a581530&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a581530",
  null
  
)

export default component.exports